"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkU7Z2BAGIjs = require('../chunk-U7Z2BAGI.js');
require('../chunk-2FWXFKPQ.js');
require('../chunk-Q4G2SZRD.js');


exports.default = _chunkU7Z2BAGIjs.Question;
//# sourceMappingURL=index.js.map